module.exports = ":host pre {\n  overflow-y: scroll;\n  white-space: pre-wrap; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sign-up/terms-modal/terms-modal.component.scss
// module id = ./src/app/components/sign-up/terms-modal/terms-modal.component.scss
// module chunks = main